module.exports = __webpack_public_path__ + "img/rebound_golden.d19e02de.svg";